export const COURSE_PAGE_EVENTS = {
  certAddToProfile: 'CP_Cert_Addtoprofile',
  certDownload: 'CP_Cert_dload',
  certShare: 'CP_Cert_share',
  certShareLi: 'CP_Cert_share_LI',
  certShareTeams: 'CP_Cert_share_Teams',
  certShareFb: 'CP_Cert_share_Fbook',
  certShareX: 'CP_Cert_share_X',
};
